<template>
    <div class="is-relative ">
        <section class="hero">
            <div class="hero-body">
                <b-loading v-if="!test || !ticket" v-model="testLoading" :is-full-page="false" />

                <div v-if="test && ticket">
                    <section class="box">
                        <h1 class="title">{{ $_get(ticket, 'title') }}</h1>
                        <p>{{ $_get(ticket, 'description') }}</p>

                        <div v-if="ticket" class="columns mt-5 is-1">
                            <div class="column">
                                <div class="buttons">
                                    <span class="px-2"><b-icon icon="ticket-outline" /> {{ticket.questionsAmount}}</span>
                                    <template v-if="testTime"><b-icon icon="timer-outline" /> {{ testTime | seconds2duration}} </template>
                                </div>
                            </div>
                            <div class="column is-right">
                                <div class="buttons is-right">
                                    <span class="px-2" style="margin-bottom: 0px">
<!--                                        <rate-icon :title="test.calculatedRate" :rate="test.calculatedRate" />-->
                                        Результат: <rate-text :rate="test.calculatedRate" />
                                    </span>
                                    <template v-if="testTime"><b-icon icon="timetable" /> {{ test.startedAt | datetime }} </template>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="box is-relative" style="min-height: 70px">
                        <b-table
                            :data="questions"
                            :loading="isLoading"
                            :selected.sync="selected"
                            striped
                            narrowed
                            hoverable
                            focusable
                        >
                            <b-table-column cell-class="is-clickable"  field="date" label="Вопрос"  v-slot="props">
                                {{ props.row.question}}
                            </b-table-column>

                            <b-table-column cell-class="is-clickable"  field="mode" label=""  centered v-slot="props">
                                <b-icon v-if="props.row.isRightAnswer" icon="checkbox-marked-outline" class="has-text-success" />
                                <b-icon v-else icon="square-off-outline" class="has-text-danger" />
                            </b-table-column>
                        </b-table>
                    </section>
                </div>
                <div v-else-if="!testLoading">
                    Что-то пошло не так
                </div>
            </div>
        </section>
        <b-modal
            v-model="isComponentModalActive"
        >
            <header class="modal-card-head">
                <p class="modal-card-title">Ваш ответ</p>
            </header>
            <section class="modal-card-body">
                <template v-if="selected">
                    <section class="section">
                        <div class="columns">
                            <div class="column is-8 is-offset-2">
                                <div class="content is-medium">
                                    <h2 class="subtitle is-4">{{ selected.question }}</h2>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-8 is-offset-2">
                                <div class="content is-medium">
                                    <template v-if="selectedAnswerType === TYPE_MULTIPLE">
                                        <b-field v-for="option in selectedOptions">
                                            <b-checkbox disabled :native-value="option.id" v-model="results">
                                                {{ option.text }}
                                            </b-checkbox>
                                        </b-field>
                                    </template>
                                    <template v-if="selectedAnswerType === TYPE_SINGLE">
                                        <b-field v-for="option in selectedOptions">
                                            <b-radio :native-value="option.id" disabled v-model="results">
                                                {{ option.text }}
                                            </b-radio>
                                        </b-field>
                                    </template>
                                    <template v-if="selectedAnswerType === TYPE_MULTIPLE_SEQUENCE || selectedAnswerType === TYPE_SINGLE_SEQUENCE">
                                        <div class="mb-5">
                                            <ul>
                                                <li v-for="option in selectedOptions">{{ option.text }}</li>
                                            </ul>
                                        </div>

                                        <div>
                                            <b-field v-for="(it, i) in resultedItems" :key="i" class="is-clickable">
                                                <b-tag
                                                    type="is-success"

                                                    closeType='is-danger'
                                                    aria-close-label="Close tag"
                                                    class="tag__custom">
                                                    {{i+1}}. {{ it.text }}
                                                </b-tag>
                                            </b-field>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-8 is-offset-2">
                                <div class="content is-medium " :class="{'has-text-success': selected && selected.isRightAnswer, 'has-text-danger': !(selected && selected.isRightAnswer)}">
                                    Ответ {{selected && selected.isRightAnswer ? '' :'не' }}правильный
                                </div>
                            </div>
                        </div>
                    </section>
                </template>
                <template v-else>
                    Нет ответа
                </template>

            </section>
            <footer class="modal-card-foot">
                <b-button
                    label="Закрыть"
                    @click="isComponentModalActive = false" />
            </footer>
        </b-modal>
    </div>
</template>
<script>
import QuestionItem from './QuestionItem'
import { mapActions, mapGetters } from 'vuex'
import { map, random, find, isArray } from 'lodash'
import { DateTime } from "luxon"

import {
    TYPE_MULTIPLE,
    TYPE_MULTIPLE_SEQUENCE,
    TYPE_SINGLE,
    TYPE_SINGLE_SEQUENCE,
} from '../../../../../store/models/questions/model'


export default {
    props: {
        testId: {
            type: String,
            required: true
        }
    },
    components: {
        QuestionItem
    },

    data() {
        return {
            selected: null,
            isComponentModalActive: false,
            results: null
        }
    },

    created () {
        this.fetchTestById(this.testId)
        this.fetchQuestions(this.testId)
    },

    methods: {
        ...mapActions({
            fetchTestById: 'e/tests/fetchById',
            fetchQuestionById: 'e/questions/fetchById',
            fetchQuestions: 'e/questions/fetchItems',
        }),
        isRight() {
            return random(0, 1) === 1
        },
        loadQuestion () {
            if (!this.test || !this.test.questions) {
                return
            }

            for(let i in this.test.questions) {
                setTimeout(()=>{
                    this.fetchQuestionById({testId: this.test.id, questionId: this.test.questions[i].id})
                }, 100 * i)
            }
        },
        fillResults() {
            if (!this.selectedQuestion) return
            let question = this.selectedQuestion

            let res = map(question.userOptions, 'id')

            const isNotEmpty = (isArray(res) && res.length !== 0) || (!isArray(res) && !!res)
            if (isNotEmpty) {
                this.results = question.answerType === TYPE_SINGLE ? this.$_get(res, '0') : res
            }
        }
    },
    computed: {
        ...mapGetters({
            testById: 'e/tests/testById',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
        testLoading() {
            return this.isLoaderActive('tests.fetchById')
        },
        questionsLoading() {
            return this.isLoaderActive('questions.fetchItems')
        },
        isLoading() {
            return this.isLoaderActive('questions.fetchById')
        },
        test () {
            return this.testById(this.testId)
        },
        ticket () {
            return this.$_get(this.test, 'ticket')
        },
        questions() {
            return this.$_get(this.test, 'questions', [])
        },
        selectedOptions() {
            if (!this.selected) {
                return []
            }

            return this.$_get(this.selectedQuestion, 'options', [])
        },
        selectedAnswerType() {
            if (!this.selected) {
                return []
            }

            return this.$_get(this.selectedQuestion, 'answerType')
        },
        selectedQuestion() {
            if (!this.selected) {
                return null
            }
            return find(this.questions, question => question.id === this.selected.id)
        },
        testTime() {
            return parseInt(DateTime.fromISO(this.test.finishedAt, {zone: 'UTC'}).diff(DateTime.fromISO(this.test.startedAt, {zone: 'UTC'}), ['seconds']).seconds)
        },
        TYPE_SINGLE_SEQUENCE() {
            return TYPE_SINGLE_SEQUENCE
        },
        TYPE_MULTIPLE_SEQUENCE() {
            return TYPE_MULTIPLE_SEQUENCE
        },
        TYPE_SINGLE() {
            return TYPE_SINGLE
        },
        TYPE_MULTIPLE() {
            return TYPE_MULTIPLE
        },
        resultedItems() {
            if (!this.selectedQuestion) return []
            let question = this.selectedQuestion

            return question.userOptions
        }
    },
    watch: {
        test (val, old) {
            if (!old && val) {
                //this.loadQuestion()
            }
        },
        'selected': {
            handler (val) {
                if (val.options.length === 0) {
                    this.fetchQuestionById({testId: this.test.id, questionId: val.id}).then(()=>{
                        this.fillResults()
                        this.isComponentModalActive = true
                    })
                } else {
                    this.fillResults()
                    this.isComponentModalActive = true
                }

            }

        }
    }
}
</script>
